import React from 'react'
import axios from 'axios'

import Cabecalho from './Form/Cabecalho'

const estilo = {
    principal: {
        textAlign: "left", color: "#484848", marginTop: "1vh"
    },
    input: {
        backgroundColor: "#00000000", border: "1px solid #00000029", borderRadius: "5px", minHeight: "5px", height: "auto"
    },
    header: {
        margin: "auto", marginTop: "20px", marginBottom: "1vh",
        color: "#087C4A", fontWeight: "bold"
    }
}

export default class PafCapa extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }
    componentDidMount() {
        const id = this.props.match.params.id
        const url = `/api/paf/getPaf/${id}`
        axios(url)
            .then(resp => {
                this.setState({ list: resp.data })
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    render() {
        if (this.state.list) {
            let ano = this.state.list.data.slice(0, 4)
            let mes = this.state.list.data.slice(5, 7)
            let dia = this.state.list.data.slice(8, 10)
            let data = dia + "/" + mes + "/" + ano
            return (
                <React.Fragment>
                    <div className="container">
                        <Cabecalho valor={this.state.list} />
                        <div style={estilo.principal}>
                            <div>CPF/CNPJ</div>
                            <div style={{ ...estilo.input, width: "40vw" }} >{this.state.list.cpfCnpj}</div>
                        </div>
                        <div style={estilo.principal}>
                            <div>Processo</div>
                            <div style={{ ...estilo.input, width: "40vw" }} >{this.state.list.numero}</div>
                        </div>
                        <div style={estilo.principal}>
                            <div>Data</div>
                            <div style={{ ...estilo.input, width: "40vw" }} >{data}</div>
                        </div>
                        <div style={estilo.header}>DADOS DO ESTABELECIMENTO</div>
                        <div className="form-group row mt-3 text-left">
                            <div style={estilo.principal}>
                                <div>Estabelecimento</div>
                                <div style={{ ...estilo.input, width: "80vw" }} >{this.state.list.estabelecimento}</div>
                            </div>
                            <div style={estilo.principal}>
                                <div>Nome Fantasia</div>
                                <div style={{ ...estilo.input, width: "80vw" }} >{this.state.list.fantasia}</div>
                            </div>
                            <div style={estilo.principal}>
                                <div>Registro</div>
                                <div style={{ ...estilo.input, width: "80vw" }} >{this.state.list.registro}</div>
                            </div>
                            <div style={estilo.principal}>
                                <div>Endereço</div>
                                <div style={{ ...estilo.input, width: "80vw" }} >{this.state.list.endereco}</div>
                            </div>
                            <div style={estilo.principal}>
                                <div>UF</div>
                                <div style={{ ...estilo.input, width: "38vw", marginRight: "4vw" }} >{this.state.list.uf}</div>
                            </div>
                            <div style={estilo.principal}>
                                <div>Município</div>
                                <div style={{ ...estilo.input, width: "38vw" }} >{this.state.list.municipio}</div>
                            </div>
                            <div style={estilo.principal}>
                                <div>CEP</div>
                                <div style={{ ...estilo.input, width: "38vw", marginRight: "4vw" }} >{this.state.list.cep}</div>
                            </div>
                            <div style={estilo.principal}>
                                <div>Telefone</div>
                                <div style={{ ...estilo.input, width: "38vw" }} >{this.state.list.telefone}</div>
                            </div>
                            <div style={estilo.principal}>
                                <div>Situação</div>
                                <div style={{ ...estilo.input, width: "38vw", marginRight: "4vw" }} >{this.state.list.setor}</div>
                            </div>
                            <div style={estilo.principal}>
                                <div>Tipo</div>
                                <div style={{ ...estilo.input, width: "38vw" }} >{this.state.list.tipo}</div>
                            </div>
                            <div style={estilo.principal}>
                                <div>Classe do Estabelecimento</div>
                                <div style={{ ...estilo.input, width: "38vw", marginRight: "4vw", 
                                    color: this.state.list.classeEstabelecimento ? 'black' : "#00000000"
                                 }} >{this.state.list?.classeEstabelecimento || 'X'}</div>
                            </div>
                            <div style={estilo.principal}>
                                <div>Observações</div>
                                <div style={{ ...estilo.input, width: "80vw" }} >{this.state.list.obs}</div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }
}
